// routingGraph.schema.ts
import { z } from "zod";
import { ZProjectNo } from "./foundationSchema";
import { ZGeometry } from "./mcbim.schema";
export const ZVec3M = z.array(z.number()).min(3).max(3);
export const ZProfile = z.enum(["CIRCULAR", "RECTANGULAR"]);
export const ZSize = z.union([
    z.object({
        diameterM: z.number().positive(),
    }),
    z.object({
        widthM: z.number().positive(),
        heightM: z.number().positive(),
    }),
]);
export const ZRoutingNodeKind = z.enum(["JUNCTION", "DEVICE_PORT"]);
export const ZDevicePort = z.enum(["IN", "OUT"]);
export const ZDeviceRef = z.object({
    deviceId: z.string().min(1),
    // Optional denormalized snapshot for UX/debug. Do not treat as source of truth.
    compCodeSnapshot: z.string().optional(),
    port: ZDevicePort.optional(),
});
export const ZRoutingNode = z
    .object({
    id: z.string().min(1),
    posM: ZVec3M,
    kind: ZRoutingNodeKind.default("JUNCTION"),
    deviceRef: ZDeviceRef.optional(),
    rooms: z.array(z.string()).optional(),
    perimeter: z.boolean().optional(),
})
    .superRefine((node, ctx) => {
    if (node.kind === "DEVICE_PORT" && !node.deviceRef) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "deviceRef is required when kind is DEVICE_PORT",
            path: ["deviceRef"],
        });
    }
    if (node.kind === "DEVICE_PORT" && node.deviceRef && !node.deviceRef.port) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "deviceRef.port is required when kind is DEVICE_PORT",
            path: ["deviceRef", "port"],
        });
    }
});
export const ZRoutingEdge = z.object({
    id: z.string().min(1),
    from: z.string().min(1),
    to: z.string().min(1),
    compCode: z.string().min(1),
    profile: ZProfile,
    size: ZSize,
});
export const ZRoutingGraph = z.object({
    _id: z.any().optional(), // mongoDB ObjectId or string, optional because it might not exist before saving to DB
    projectNo: ZProjectNo,
    systemCode: z.string().min(1),
    systemName: z.string().min(1).optional(),
    floorName: z.string().min(1),
    roomNumber: z.string().min(1).optional(),
    nodes: z.array(ZRoutingNode),
    edges: z.array(ZRoutingEdge),
});
export const ZRoutingPipeWithMcBimGeometry = z.object({
    system: z.string().min(1),
    compCode: z.string().min(1),
    dimension: z.number(),
    geometry: ZGeometry,
});
export const ZRoutingPipesWithMcBimGeometry = z.object({
    pipes: z.array(ZRoutingPipeWithMcBimGeometry),
});
